import React from 'react'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

/**
 * Los avisos del panel.
 *
 * `message` puede ser texto o un nodo de React, y `opciones` son las de
 * react-toastify: `autoClose`, `onClose`, `toastId`, `className`… Se añadieron
 * en URBWEB-4385, cuando el centro de notificaciones necesitaba un aviso con
 * título, cuerpo y un enlace dentro.
 *
 * Hacía falta decidir entre ampliar esto o montar un segundo sistema de
 * avisos, y un segundo sistema son dos lenguajes visuales y dos sitios donde
 * apilar mensajes que no se conocen entre sí. Ampliar costaba una línea por
 * método.
 */
export const showToast = {
  success: (message, opciones) => toast.success(message, opciones),
  error: (message, opciones) => toast.error(message, opciones),
  info: (message, opciones) => toast.info(message, opciones),
  warning: (message, opciones) => toast.warning(message, opciones),
  default: (message, opciones) => toast(message, opciones)
}

export const ToastProvider = ({ children }) => {
  return (
    <>
      {children}
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  )
}
